<template>
  <span>
    <h1>Gestion du Blog</h1>
    <el-row :gutter="10" type="flex" >
      <el-col :span="4" class="menu-left" >
        <ul>
          <li
             v-for="doc in docs"
             :class="{fakelink: true, current: editedDoc.id && editedDoc.id === doc.id}"
             @click="edit(doc)" >
            <el-tooltip
               :content="doc.title"
               :visible-arrow="false"
               placement="top-start"
               :open-delay="1000" >
              <span>
                {{ doc.title }}
                <span v-if="editedDoc.id && editedDoc.id === doc.id && editing" class="editing" >*</span>
              </span>
            </el-tooltip>
          </li>
          <li>
            <el-button type="primary" @click="edit({})" >
              Nouveau
            </el-button>
          </li>
        </ul>
      </el-col>
      <el-col :span="20" >
        <edit-post v-model="editedDoc" @change="change" :quill="quill" >
          <slot name="toolbar" slot="toolbar" ></slot>
        </edit-post>
      </el-col>
    </el-row>
  </span>
</template>

<style scoped>
* {
    text-align: left;
}
h1 {
    text-align: center;
}
.editing {
    color: #FF4949;
}
</style>

<script>
import {api} from 'macarons'
import Post from './Post.vue'
import EditPost from './EditPost.vue'

export default {
  components: {
    EditPost: EditPost
  },
  props: {
    quill: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      editedDoc: {},
      editing: false,
      docs: []
    }
  },
  mounted () {
    api.get('blog/posts').then(({data}) => {
      this.docs.splice(0, this.docs.length, ...data)
    })
  },
  methods: {
    edit (doc) {
      this.editedDoc = doc
      this.editing = false
    },
    change (editing) {
      this.editing = editing
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-blog/Admin.vue